import grantsCriteria from '~/cms/grants-criteria.json'
import grantsGroups from '~/cms/grants-groups.json'
import {
	ALWAYS_POSSIBLE_HEATING_SYSTEMS,
	ALWAYS_UNGEEIGNET_HEATING_SYSTEMS,
	type AlwaysPossibleHeatingSystemType,
	type AlwaysUnsuitableHeatingSystemType,
	BIOMASSE_HEATING_SYSTEMS,
	type BioMasseHeatingSystemType,
	FERNWAERME_HEATING_SYSTEMS,
	type FernwaermeHeatingSystemType,
	WAERME_PUMPE_HEATING_SYSTEMS,
	type WaermePumpeHeatingSystemType,
} from '~/shared/config/heatingsystem'
import type { GrantsGroupKey } from '~/shared/types/grants'

export const isFernwaermeHeatingSystem = (E_ID: string): E_ID is FernwaermeHeatingSystemType => {
	return FERNWAERME_HEATING_SYSTEMS.includes(E_ID as FernwaermeHeatingSystemType)
}

export const isBioMasseHeatingSystem = (E_ID: string): E_ID is BioMasseHeatingSystemType => {
	return BIOMASSE_HEATING_SYSTEMS.includes(E_ID as BioMasseHeatingSystemType)
}

export const isAlwaysPossibleHeatingSystem = (E_ID: string): E_ID is AlwaysPossibleHeatingSystemType => {
	return ALWAYS_POSSIBLE_HEATING_SYSTEMS.includes(E_ID as AlwaysPossibleHeatingSystemType)
}

export const isAlwaysUnsuitableHeatingSystem = (E_ID: string): E_ID is AlwaysUnsuitableHeatingSystemType => {
	return ALWAYS_UNGEEIGNET_HEATING_SYSTEMS.includes(E_ID as AlwaysUnsuitableHeatingSystemType)
}

export const isWaermePumpeHeatingSystem = (E_ID: string): E_ID is WaermePumpeHeatingSystemType => {
	return WAERME_PUMPE_HEATING_SYSTEMS.includes(E_ID as WaermePumpeHeatingSystemType)
}

export const getPolygonLayersByHeatingSystem = (E_ID: string) => {
	if (E_ID === 'KollektorWP') {
		return [6, 11]
	} else if (E_ID === 'SoleWP') {
		return [4, 10]
	} else if (E_ID === 'WasserWP') {
		return [6, 12]
	} else if (['FWe', 'FW', 'FWh'].includes(E_ID)) {
		return [30, 31, 32, 34]
	}
}

export const categorizeGrantsHeatingSystemFromCMS = (E_ID: string): GrantsGroupKey | null => {
	const groupKey = grantsGroups.systemToGroup[E_ID as keyof typeof grantsGroups.systemToGroup]
	return (groupKey as GrantsGroupKey) || null
}

export const categorizeGrantsHeatingSystemAdvanced = (
	E_ID: string
): GrantsGroupKey | 'fw-klassisch' | 'fw-varianten' | null => {
	if (E_ID === 'FW') {
		return 'fw-klassisch'
	}
	if (E_ID === 'FWh' || E_ID === 'FWe') {
		return 'fw-varianten'
	}
	return categorizeGrantsHeatingSystemFromCMS(E_ID)
}

export const isSwapEligible = (
	sourceGroup: GrantsGroupKey | 'fw-klassisch' | 'fw-varianten',
	targetGroup: GrantsGroupKey | 'fw-klassisch' | 'fw-varianten'
): boolean => {
	const eligibleSwaps = (grantsCriteria.eligibleSwaps as any)[sourceGroup]
	return eligibleSwaps ? eligibleSwaps.includes(targetGroup) : false
}

export const getEligibleTargetGroups = (sourceGroup: GrantsGroupKey | 'fw-klassisch' | 'fw-varianten'): string[] => {
	return (grantsCriteria.eligibleSwaps as any)[sourceGroup] || []
}
